import React from "react";

const index = ({ title, image, content, alt, onOpen }) => {
  return (
    <div className="card" onClick={onOpen}>
      <div className="image">
        <div className="imageContainer">
          <img src={image} alt={alt} />
        </div>
      </div>
      <div className="contentBox">
        <div className="titleText">{title}</div>
        <div className="content">{content}</div>
      </div>
    </div>
  );
};

export default index;
